import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import * as AdminService from 'services/iam/guest';

export const useAdminService = () => {
  const { token } = useSelector((store) => store.user_data);

  const fetchAdmins = async (options = {}) => {
    const { error, payload } = await AdminService.read({ ...options, token });
    if (error) {
      toast.error('Unable to fetch admins at this time.');
      return { admins: [], size: 0 };
    }

    const {
      data: admins,
      meta: { size }
    } = payload;
    return { admins, size };
  };

  const createAdmin = async (data, options = {}) => {
    const { error, payload: admin } = await AdminService.signup({ ...options, data, token });
    if (error) {
      toast.error(error || 'Unable to add admin at this time.');
      return { admin: null, success: false };
    }

    toast.success('Admin added successfully.');
    return { admin, success: true };
  };

  const deleteAdmin = async (id, options = {}) => {
    const { error } = await AdminService.deleteOne(id, { ...options, token });
    if (error) {
      toast.error('Unable to remove admin at this time.');
      return false;
    }

    toast.success('Admin removed successfully.');
    return true;
  };

  const login = async (options = {}) => {
    const { error, payload: tenant } = await AdminService.login({ ...options, token });
    if (error) {
      toast.error('Unable to fetch tenants at this time.');
      return { tenant: null, error };
    }

    return { tenant, error: null };
  };

  const resetPassword = async (options = {}) => {
    const { error } = await AdminService.resetPassword({ ...options, token });
    if (error) {
      toast.error('Unable to update tenant at this time.');
      return false;
    }

    toast.error('Password updated successfully.');
    return true;
  };

  return { fetchAdmins, createAdmin, deleteAdmin, login, resetPassword };
};
